// BackDropCallsHub.jsx
import React, { useState, useMemo } from 'react'
import { useDispatch } from 'react-redux';
import {
    createRoomChat,
    setActiveChatIdLocal
} from '../actions/chatActions';
import Loader from '../components/Loader';

const ago = (d) => {
    if (!d) return 'никогда';
    const sec = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
    if (sec < 60) return 'только что';
    const m = Math.floor(sec / 60);
    if (m < 60) return `${m} мин назад`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h} ч назад`;
    const dd = Math.floor(h / 24);
    return `${dd} дн назад`;
};

const BackDropCallsHub = ({
    composeOpen,
    setComposeOpen,
    isMobile,
    me,
    setView,
    q,
    onlineIds,
    users,
    lastSeen,
    usersLoading,
}) => {
    const [roomTitle, setRoomTitle] = useState('');
    const [roomMembers, setRoomMembers] = useState([]);

    const dispatch = useDispatch();

    const filteredUsers = useMemo(() => {
        const ql = q.trim().toLowerCase();
        return users
            .filter(u => u._id !== me?._id)
            .filter(u =>
                !ql ||
                u.email?.toLowerCase().includes(ql) ||
                u.firstName?.toLowerCase().includes(ql) ||
                u.lastName?.toLowerCase().includes(ql)
            )
            .sort((a, b) => {
                const ao = onlineIds.has(String(a._id)) ? 0 : 1;
                const bo = onlineIds.has(String(b._id)) ? 0 : 1;
                if (ao !== bo) return ao - bo;
                const an = `${a.lastName || ''}${a.firstName || ''}`;
                const bn = `${b.lastName || ''}${b.firstName || ''}`;
                return an.localeCompare(bn);
            });
    }, [users, onlineIds, q, me]);

    const createRoom = async () => {
        const uniq = Array.from(new Set(roomMembers.filter(id => id !== me?._id)));
        if (!roomTitle.trim() || uniq.length === 0) return;
        const res = await dispatch(createRoomChat({ title: roomTitle.trim(), participants: [me._id, ...uniq] }));
        const chatId = res?.payload?.chat?._id;
        if (chatId) {
            dispatch(setActiveChatIdLocal(chatId));
            setComposeOpen(false);
            setRoomTitle('');
            setRoomMembers([]);
        }
    };

    const toggleMember = (uid) => {
        setRoomMembers(p => (p.includes(uid) ? p.filter(x => x !== uid) : [...p, uid]));
    };

    return composeOpen && <>
        <div className="callsHub__backdrop" onClick={() => setComposeOpen(false)} />

        <div className={`callsHub__sheet ${composeOpen ? 'is-open' : ''}`}>
            <div className="callsHub__sheetHead">
                <div className="callsHub__sheetTitle">Создать</div>
                <button className="iconBtn" onClick={() => setComposeOpen(false)}>✕</button>
            </div>
            <div className="callsHub__sheetActions">
                <button className="btn" onClick={() => setView('contacts')}>Новый чат</button>
                <button className="btn" onClick={() => { /* пока пусто */ }}>Новая группа</button>
            </div>
            <div className="callsHub__sheetGroup">
                <input
                    className="input"
                    placeholder="Название группы"
                    value={roomTitle}
                    onChange={e => setRoomTitle(e.target.value)}
                />
                <div className="callsHub__sheetHint">Добавь участников:</div>
                <div className="callsHub__picker">
                    {usersLoading ? (
                        <div style={{ display: 'grid', placeItems: 'center', padding: 16, opacity: .85 }}>
                            <Loader typeSize="46px" />
                        </div>
                    ) : (
                        filteredUsers.map(u => {
                            const sel = roomMembers.includes(u._id);
                            return (
                                <label key={u._id} className={`callsHub__pick ${sel ? 'is-sel' : ''}`}>
                                    <input type="checkbox" checked={sel} onChange={() => toggleMember(u._id)} />
                                    <span className="callsHub__pickAvatar">{(u.firstName || u.email || 'U').slice(0, 1)}</span>
                                    <span className="callsHub__pickName">{u.firstName} {u.lastName}</span>
                                    <span className="callsHub__pickMeta">{onlineIds.has(String(u._id)) ? 'онлайн' : ago(lastSeen[u._id])}</span>
                                    <span className={`callsHub__onlineDot ${onlineIds.has(String(u._id)) ? 'is-on' : ''}`} />
                                </label>
                            );
                        })
                    )}
                </div>
                <button className="btn btn--primary btn--block" onClick={createRoom}>Создать группу</button>
            </div>
        </div>
    </>
}

export default BackDropCallsHub
